import { render } from "./CardViewer.vue?vue&type=template&id=0ea23da6&scoped=true"
import script from "./CardViewer.vue?vue&type=script&lang=js"
export * from "./CardViewer.vue?vue&type=script&lang=js"

import "./CardViewer.vue?vue&type=style&index=0&id=0ea23da6&lang=scss&scoped=true"
import "./CardViewer.vue?vue&type=style&index=1&id=0ea23da6&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea23da6"]])

export default __exports__